import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Link } from 'base-ui'

import { StaticImage } from '../../../image'

import appQRCodeV2 from './app-qr-code-v2.png'
import appRatings from './app-ratings.jpg'

const urlResolverGoToNfcAtShopApothekeAppV2 = (): string =>
  'https://shop-apotheke-com.onelink.me/d95Q?pid=Onsite&af_channel=DE&c=Onsite_DE_QRCode_NFC_LP_QRCode_V2_04_07_24&af_adset=QRCode&af_ad=NFC_LP_QRCode_V2&af_dp=sae://erx&deep_link_value=sae://erx&af_sub1=&af_web_dp=https://www.shop-apotheke.com/lp/shop-apotheke-app'

export const NfcLandingPageHowItWorksSectionAppBannerDesktop: FC = () => {
  const intl = useIntl()

  return (
    <Link
      aria-label={intl.formatMessage({ id: 'erx-banner-link.aria-label' })}
      className="flex items-center gap-6 overflow-hidden rounded-2xl bg-light-secondary-medium p-6 text-inherit no-underline hover:text-inherit"
      href={urlResolverGoToNfcAtShopApothekeAppV2()}
    >
      <span className="flex-1 text-2xl font-medium">
        <FormattedMessage id="nfc.howItWorks.banner.title.new" />
        <br />
        <span className="whitespace-nowrap italic text-dark-accent">
          <FormattedMessage id="nfc.howItWorks.banner.highlightedText.new" />
        </span>
      </span>

      <div className="relative flex flex-1 items-center gap-4 rounded-2xl bg-light-primary-low p-4">
        <StaticImage
          alt={intl.formatMessage({
            id: 'erx.banner-link.app-badge.alt',
          })}
          height={92}
          src={appRatings}
          width={160}
        />
        <StaticImage
          alt={intl.formatMessage({
            id: 'nfc.howItWorks.images.appQR',
          })}
          height={80}
          /*
           * `id` added to build a bridge between web and app, allowing to change this element dynamically
           * ref: https://jira.shop-apotheke.com/browse/WSERX-575
           */
          id="app_qr_code"
          src={appQRCodeV2}
          width={80}
        />
        <span className="text-m font-medium">
          <FormattedMessage id="nfc.howItWorks.banner.appText" />
        </span>
        <div className="absolute -top-3 left-72 w-max rounded bg-light-tertiary px-1 text-xs font-medium">
          <FormattedMessage id="nfc.howItWorks.banner.badge.v1" />
        </div>
      </div>
    </Link>
  )
}
